import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Text, Card, Grid, Col, Accordion, Loader, TextInput } from '@mantine/core';
import Layout from '../../../Layout/Layout';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getVehicle } from '../../../actions/vehicleActions';
import { getCustomer } from '../../../actions/customerActions';
import moment from 'moment';

const Vehicle = ({ title }) => {

    const params = useParams();
    const dispatch = useDispatch();
    const { loading: vehicleLoading, vehicle: vehicleInfo } = useSelector((state) => state.vehicle);
    const { loading: customerLoading, customer: customerInfo } = useSelector((state) => state.customer);

    useEffect(() => {
        dispatch(getVehicle(params.id))
    }, [dispatch, params.id])

    useEffect(() => {
        if (vehicleInfo && Object.keys(vehicleInfo).includes('vehicle')) {
            dispatch(getCustomer(vehicleInfo.vehicle.customerId))
        }
        // eslint-disable-next-line
    }, [vehicleInfo])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
            </Helmet>
            <Layout activeKey={6}>
                {/* <Accordion iconPosition="left" offsetIcon={true}>
                    <Accordion.Item opened label="Vehicle Information" icon={
                        <ThemeIcon color="violet" variant="light">
                            <FaUber />
                        </ThemeIcon>
                    }>
                        <Grid>
                            <Col span={12}>
                                <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                            </Col>
                            <Col span={12}>
                                <Text> {vehicleInfo.vehicle.make} {vehicleInfo.vehicle.model}</Text>
                            </Col>
                            <Col span={12}>
                                <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                            </Col>
                            <Col span={12}>
                                <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                            </Col>
                            <Col span={12}>
                                <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                            </Col>
                            <Col span={12}>
                                <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                            </Col>
                            <Col span={12}>
                                <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                            </Col>
                        </Grid>
                    </Accordion.Item>

                    <Accordion.Item label="Flexibility">
                        Configure components appearance and behavior with vast amount of settings or overwrite any part of component styles
                    </Accordion.Item>

                    <Accordion.Item label="No annoying focus ring">
                        With new :focus-visible pseudo-class focus ring appears only when user navigates with keyboard
                    </Accordion.Item>
                </Accordion> */}
                {vehicleLoading ? <Loader /> : vehicleInfo ? <Card radius='md' shadow="sm" withBorder>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                        <Text weight={700} size='xl'>Vehicle Information</Text>
                    </span>
                    <Grid sx={{ margin: '20px 0' }}>
                        <Col span={4}>
                            <TextInput size='md' label='Vehicle number' radius='md' readOnly value={vehicleInfo.vehicle.vehicleNo} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Vehicle make' radius='md' readOnly value={vehicleInfo.vehicle.make} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Vehicle model' radius='md' readOnly value={vehicleInfo.vehicle.model} />
                        </Col>
                    </Grid>
                    <Grid sx={{ margin: '20px 0' }}>
                        <Col span={4}>
                            <TextInput size='md' label='Last recorded mileage' radius='md' readOnly value={vehicleInfo.vehicle.lastMileage} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Year of Manufacture' radius='md' readOnly value={moment(vehicleInfo.vehicle.YOM).format('YYYY')} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Vehicle chassis' radius='md' readOnly value={vehicleInfo.vehicle.chassisNo ? vehicleInfo.vehicle.chassisNo : 'No Chassis Number'} />
                        </Col>
                    </Grid>
                    <Grid sx={{ margin: '20px 0' }}>
                        <Col span={4}>
                            <TextInput size='md' label='Last service' radius='md' readOnly value={moment(vehicleInfo.vehicle.updatedAt).format('DD-MMM-YYYY')} />
                        </Col>
                    </Grid>
                </Card> : <></>}
                {customerLoading ? <Loader /> : customerInfo ? <Card sx={{ marginTop: '20px' }} radius='md' shadow="sm" withBorder>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                        <Text weight={700} size='xl'>Owner Information</Text>
                    </span>
                    <Grid sx={{ margin: '20px 0' }}>
                        <Col span={4}>
                            <TextInput size='md' label='Owner firstname' radius='md' readOnly value={customerInfo.firstname} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Owner lastname' radius='md' readOnly value={customerInfo.lastname} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Owner NIC' radius='md' readOnly value={customerInfo.nic} />
                        </Col>
                    </Grid>
                    <Grid sx={{ margin: '20px 0' }}>
                        <Col span={4}>
                            <TextInput size='md' label='Owner email' radius='md' readOnly value={customerInfo.email} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Owner phone' radius='md' readOnly value={customerInfo.contact} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Owner date of birth' radius='md' readOnly value={moment(customerInfo.dob).format('DD-MMM-YYYY')} />
                        </Col>
                    </Grid>
                    <Grid sx={{ margin: '20px 0' }}>
                        <Col span={12}>
                            <TextInput size='md' label='Owner Address' radius='md' readOnly value={customerInfo.houseNo + ", " + customerInfo.streetAddress + ", " + customerInfo.city} />
                        </Col>
                    </Grid>
                    <Grid sx={{ margin: '20px 0' }}>
                        <Col span={6}>
                            <TextInput size='md' label='Joined' radius='md' readOnly value={moment(customerInfo.createdAt).format('DD-MMM-YYYY')} />
                        </Col>
                        <Col span={6}>
                            <TextInput size='md' label='Last updated' radius='md' readOnly value={moment(customerInfo.updatedAt).format('DD-MMM-YYYY')} />
                        </Col>
                    </Grid>
                </Card> : <></>}
                {vehicleLoading ? <Loader /> : vehicleInfo ? <Card sx={{ marginTop: '20px' }} radius='md' shadow="sm" withBorder>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                        <Text weight={700} size='xl'>Work History</Text>
                    </span>
                    <Grid sx={{ margin: '20px 0' }}>
                        <Col span={4}>
                            <TextInput size='md' label='Vehicle number' radius='md' readOnly value={vehicleInfo.vehicle.vehicleNo} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Vehicle make' radius='md' readOnly value={vehicleInfo.vehicle.make} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Vehicle model' radius='md' readOnly value={vehicleInfo.vehicle.model} />
                        </Col>
                    </Grid>
                    <Grid sx={{ margin: '20px 0' }}>
                        <Col span={4}>
                            <TextInput size='md' label='Last recorded mileage' radius='md' readOnly value={vehicleInfo.vehicle.lastMileage} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Year of Manufacture' radius='md' readOnly value={moment(vehicleInfo.vehicle.YOM).format('YYYY')} />
                        </Col>
                        <Col span={4}>
                            <TextInput size='md' label='Vehicle chassis' radius='md' readOnly value={vehicleInfo.vehicle.chassisNo ? vehicleInfo.vehicle.chassisNo : 'No Chassis Number'} />
                        </Col>
                    </Grid>
                    <Grid sx={{ margin: '20px 0' }}>
                        <Col span={4}>
                            <TextInput size='md' label='Last service' radius='md' readOnly value={moment(vehicleInfo.vehicle.updatedAt).format('DD-MMM-YYYY')} />
                        </Col>
                    </Grid>
                </Card> : <></>}
                {vehicleLoading ? <Loader /> : vehicleInfo ? <Card sx={{ marginTop: '20px' }} radius='md' shadow="sm" withBorder>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                        <Text weight={700} size='xl'>Invoices</Text>
                    </span>
                    <Accordion iconPosition="left" offsetIcon={true}>
                        {vehicleInfo.invoices.map((invoice) => {

                            return <Accordion.Item opened label={moment(invoice.date).format('DD-MMM-YYYY')}>
                                <Grid>
                                    <Col span={12}>
                                        <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                    </Col>
                                    <Col span={12}>
                                        <Text> {vehicleInfo.vehicle.make} {vehicleInfo.vehicle.model}</Text>
                                    </Col>
                                    <Col span={12}>
                                        <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                    </Col>
                                    <Col span={12}>
                                        <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                    </Col>
                                    <Col span={12}>
                                        <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                    </Col>
                                    <Col span={12}>
                                        <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                    </Col>
                                    <Col span={12}>
                                        <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                    </Col>
                                </Grid>
                            </Accordion.Item>


                        })}
                    </Accordion>
                    {/* <Accordion iconPosition="left" offsetIcon={true}>
                        <Accordion.Item opened label="Vehicle Information" icon={
                            <ThemeIcon color="violet" variant="light">

                            </ThemeIcon>
                        }>
                            <Grid>
                                <Col span={12}>
                                    <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                </Col>
                                <Col span={12}>
                                    <Text> {vehicleInfo.vehicle.make} {vehicleInfo.vehicle.model}</Text>
                                </Col>
                                <Col span={12}>
                                    <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                </Col>
                                <Col span={12}>
                                    <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                </Col>
                                <Col span={12}>
                                    <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                </Col>
                                <Col span={12}>
                                    <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                </Col>
                                <Col span={12}>
                                    <Text color='gray'> {vehicleInfo.vehicle.vehicleNo}</Text>
                                </Col>
                            </Grid>
                        </Accordion.Item>

                        <Accordion.Item label="Flexibility">
                            Configure components appearance and behavior with vast amount of settings or overwrite any part of component styles
                        </Accordion.Item>

                        <Accordion.Item label="No annoying focus ring">
                            With new :focus-visible pseudo-class focus ring appears only when user navigates with keyboard
                        </Accordion.Item>
                    </Accordion> */}
                </Card> : <></>}

            </Layout>
        </>
    )
}

export default Vehicle
